import { string, array } from 'prop-types'
import ZoomViewer from '@components/ZoomViewer'
import { Container } from '@mch-group/uikit-components'

const ArtworksImages = ({ className, images, displayName }) => (
  <Container className={className}>
    <ZoomViewer
      images={images}
      title={displayName}
      alt={displayName}
      className='test'
      reducedSize={1.2}
    />
  </Container >
)

ArtworksImages.displayName = 'ArtworksImages'

ArtworksImages.propTypes = {
  className: string,
  displayName: string,
  images: array
}

export default ArtworksImages
